export default __webpack_public_path__ + "static/media/PPP.93cb6100.png";